import { useEffect, useState } from "react";

import { Button, Input, Row } from "antd";

import EditProfile from "./EditProfile";

const EditNotice = ({ channelInfo, postContent, getInfo, user }) => {
	const [noticeBody, setNoticeBody] = useState(
		channelInfo?.notice?.content ?? ""
	);
	const [noticeEdit, setNoticeEdit] = useState(false);

	useEffect(() => {
		if (channelInfo.notice?.content) {
			setNoticeBody(channelInfo?.notice?.content);
		}
	}, [channelInfo]);

	const handleCancel = () => {
		setNoticeBody(channelInfo?.notice?.content ?? "");
		setNoticeEdit(false);
	};

	const submitNotice = () => {
		let param = {
			id: channelInfo?.notice?.id,
			title: "공지사항",
			content: noticeBody,
			is_notice: true,
			type: !channelInfo?.notice?.content ? "create" : "edit",
		};
		postContent(param);
		setNoticeEdit(false);
	};

	return (
		<div className={`edit-notice`}>
			{/* 프로필 수정 */}
			<EditProfile channelInfo={channelInfo} getInfo={getInfo} user={user} />
			<div className={`channel-notice-div`}>
				<div className={`channel-head`}>
					<p className={`channel-title`} style={{ fontSize: "1.4em" }}>
						공지사항
					</p>
				</div>
				<div className={`channel-body`}>
					<div className={`body-contents`}>
						{!noticeEdit ? (
							<p style={{ whiteSpace: "pre-wrap" }}>{noticeBody}</p>
						) : (
							<Input.TextArea
								placeholder={`공지사항 내용을 입력해주세요.`}
								value={noticeBody}
								name={"공지사항"}
								onChange={(e) => setNoticeBody(e.target.value)}
								style={{
									minHeight: "200px",
								}}
							/>
						)}
					</div>
					<div className={`body-comment`} style={{ justifyContent: "center" }}>
						{!noticeEdit ? (
							<Button
								size={`small`}
								className={`write-comment`}
								onClick={() => setNoticeEdit(true)}
							>
								글쓰기
							</Button>
						) : (
							<Row
								align={"middle"}
								justify={"center"}
								style={{
									gap: "0.5em",
									marginTop: "1em",
								}}
							>
								<Button size={"small"} onClick={handleCancel}>
									취소
								</Button>
								<Button
									size={"small"}
									className={`edit-success-btn`}
									onClick={submitNotice}
								>
									작성 완료
								</Button>
							</Row>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
export default EditNotice;
